var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"name","placeholder":"Search...","options":_vm.campuses,"clearable":_vm.clearable},on:{"search":_vm.onSearch},model:{value:(_vm.selectedCampus),callback:function ($$v) {_vm.selectedCampus=$$v},expression:"selectedCampus"}},[_c('template',{slot:"no-options"},[_vm._v(" Start typing to search for a campus ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }